import type { HaNPersonRow } from "@lib/logic";
import { Avatar } from "@molecules";

type PersonCellProps = {
  row: HaNPersonRow;
};

/** A person in the list: their avatar and name, and where they sit. */
export const PersonCell = ({ row }: PersonCellProps) => {
  const { owner, reservation } = row;

  const { areaName, deskName, floorName } = reservation.workspace;
  const place = [areaName, deskName, floorName].filter(Boolean).join(", ");

  return (
    <div className="flex w-full min-w-0 items-center gap-3">
      <Avatar
        className="flex-none"
        size="large"
        user={{
          id: owner.id,
          email: owner.email,
          initials: owner.initials ?? "",
          name: owner.name,
          imageHash: owner.imageHash,
        }}
      />

      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="truncate font-semibold">{owner.name}</p>
        <p className="truncate text-mapiq-black-500">{place}</p>
      </div>
    </div>
  );
};
